export enum ContainerType {
  Pallet = 'Pallet',
  Box = 'Box',
}

export enum ContainerStatus {
  Building = 'Building',
  ReadyForBilling = 'Ready for Billing',
  ReadyToShip = 'Ready to Ship',
  Assigned = 'Assigned',
  PickedUp = 'Picked Up',
}

export interface ContainerShipment {
  id: number
  carrier: string | null
  tracking_number: string | null
  bol_number: string | null
  waybill_number: string | null
  status: string
}

export interface IContainerDashboard {
  id: number
  status: string
  work_order_number: string
  shipment: ContainerShipment | null
  assigned_miners: number
  kind: string
  number: string
  type: string
  expected_miners: number
}

export interface IContainerMiner {
  id: number
  sn: string
  model: string
  mac_address: string | null
  status: string | null
}

export interface IContainerDamage {
  file_url: string
  description: string
}

export interface ICreatedContainer {
  work_order_number: string
  damages: IContainerDamage[]
  status: string | null
  shipment: ContainerShipment | null
  miners: IContainerMiner[]
}

export const ContainerTypeSelectOptions = [
  {
    key: ContainerType.Pallet,
    value: ContainerType.Pallet,
    label: ContainerType.Pallet,
  },
  {
    key: ContainerType.Box,
    value: ContainerType.Box,
    label: ContainerType.Box,
  },
]

export interface INewContainer {
  id: number
  type?: string
  number: string
  expected_miners: number | null
  damages: Array<any>
  miners: Array<any>
  length?: number
  width?: number
  height?: number
  weight?: number
}
